module.exports = __webpack_public_path__ + "static/map@2x-8d28fb8536f86c5b1500aecf2db4ba01.png";